export default __webpack_public_path__ + "static/media/iphone.d2c6d226.jpg";